module.exports = __webpack_public_path__ + "static/pane-resize-3d1e8cee75e26c823c110fe9da866e2c.mp4";